import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const enLocale = {
  message: {
    hello: 'hello world'
  }
}

const jaLocale = {
  message: {
    hello: 'こんにちは、世界'
  }
}

const messages = {
  en: enLocale,
  ja: jaLocale,
}

let defaultLocale = 'en'
if (window) {
  const storageLocale = window.localStorage.getItem('locale')
  if (storageLocale) defaultLocale = storageLocale
}

const i18n = new VueI18n({
  locale : defaultLocale,
  fallbackLocale: 'en',
  silentTranslationWarn : true,
  messages
})

export default i18n

export function setLocale (locale) {
  i18n.locale = locale
  if (window) {
    window.localStorage.setItem('locale', locale)
    // window.location.reload()
  }
}
